<template>
    <div class="find-a-service-card">
        <div class="find-a-service-card__inner">
            <h4 class="find-a-service-card__title">
                <a :href="`/${data.url}`" v-text="data.title" @click="handleClick('title', $event)" />
            </h4>
            <div class="find-a-service-card__info">
                <div class="find-a-service-card__content">
                    <div v-html="data.excerpt" class="find-a-service__excerpt" v-if="data.excerpt" />
                </div>
                <div class="find-a-service-card__actions">
                    <a :href="`/${data.url}`" class="button find-a-service-card__action" @click="handleClick('learn_more', $event)">Learn More</a>
                    <a :href="`/find-a-doctor?service=${data.title}`" class="button -transparent find-a-service-card__action" @click="handleClick('browse_doctors', $event)">Browse Doctors</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { swiftypeClickMixin } from '../../../scripts/mixins';

export default {
    name: 'service',
    props: ['data', 'requestId', 'query'],
    mixins: [swiftypeClickMixin],
}
</script>

